import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ILogin } from "../../models/Login";
import { Button } from "primereact/button";
import { JVDropdown } from "../../shared/JVDropdown";

import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";

export interface IFilter {
    fromDate?: Date,
    toDate?: Date,
    extension_ID?: number | null,
    callerID?: string | null,
    ext_Destination?: string | null,
    displayName?: string | null,
    ivR_Company?: string | null,
    branch_Name?: string | null,
}

export const EmptyFilter: IFilter = {
    fromDate: new Date(),
    toDate: new Date(),
    extension_ID: null,
    callerID: "",
    ext_Destination: "",
    displayName: "",
}

interface IFilterProps {
    callFilter: IFilter,
    setCallFilter: (callFilter: IFilter) => void,
    history?: boolean,
}

const schema2 = yup.object({
    fromDate: yup.date().required("From Date is Required"),
    toDate: yup.date().required("To Date is Required"),
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
    req_Category: yup.number().nullable(),
    team: yup.number().nullable()
});

const schema = yup.object({
    // fromDate: yup.date().nullable(),
    // toDate: yup.date().nullable(),
    company: yup.number().nullable(),
    branch: yup.number().nullable(),
    req_Category: yup.number().nullable(),
    team: yup.number().nullable()
});

export const Filter = (props: IFilterProps) => {

    const iVR_Company = [
        { name: 'Tekinspirations' },
        { name: 'Originator' },
        { name: 'Inventivo' },
    ]
    const branch_Name_Dropdown = [
        { name: 'Varanasi' },
        { name: 'Noida' },
        { name: 'Agra' },
        { name: 'Meerut' },
        { name: 'Ranchi' },
        { name: 'Bhubaneswar' },
    ]

    const { control, handleSubmit, reset, watch } = useForm<IFilter>({
        defaultValues: props.callFilter,
        resolver: yupResolver((props.history !== undefined && props.history !== null && props.history !== false) ? schema2 : schema),
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });
    const Clear = () => {
        reset(EmptyFilter);

    };

    const searchToDB = async (body: IFilter) => {
        let filterData: any = body;
        let emptyFilter: any = EmptyFilter;
        for (let key in filterData) {
            if (filterData[key] === "-- SELECT --" || filterData[key] === 0) {
                filterData[key] = emptyFilter[key];
            }
        }
        body = filterData;
        props.setCallFilter(body);
    }

    const onSubmit = (data: IFilter) => {
        searchToDB(data);
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            {props.history !== undefined && props.history !== null && props.history !== false && <JVDate maxDate={new Date(new Date().setDate(new Date().getDate() - 1))} column={6} label="From Date" control={control} name="fromDate" />}
            {props.history !== undefined && props.history !== null && props.history !== false && <JVDate maxDate={new Date(new Date().setDate(new Date().getDate() - 1))} column={6} label="To Date" control={control} name="toDate" />}
            <JVInput column={6} label="Caller ID" control={control} name="callerID" />
            <JVInput column={6} label="Ext/ Destination" control={control} name="ext_Destination" />
            <JVInput column={6} label="User Name" control={control} name="displayName" />
            <JVDropdown column={6} label="IVR Company" control={control} name="ivR_Company" options={iVR_Company} optionLabel="name" optionValue="name" placeholder="Select IVR Company" />
            <JVDropdown column={6} label="Branch Name" control={control} name="branch_Name" options={branch_Name_Dropdown} optionLabel="name" optionValue="name" placeholder="Select Branch Name" />
            <div style={{ margin: '10px 0', width: '100%' }}></div>

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={Clear} type="button"></Button>
            </div>
        </form>
    );
}